export enum ICSStylesOverviewTestLabelEnum {
  FINISH_COLOR_LBL = 'finish-color-lbl',
  MATERIAL_COLOR_LBL = 'material-color-lbl',
  MATERIAL_GROUP_LBL = 'material-group-lbl',
  MATERIAL_NOTES_LBL = 'material-notes-lbl',
}
